import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/')({
  beforeLoad: () => {
    throw redirect({ to: '/clearing/operations/stock-record' });
  },
  preload: false,
});
